export const MULTI_LOAN_DASHBOARD_READY = 'page/MULTI_LOAN_DASHBOARD_READY';

export const MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT =
    'page/MULTI_LOAN_DASHBOARD_ENABLE_REDIRECT';
export const MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT =
    'page/MULTI_LOAN_DASHBOARD_DISABLE_REDIRECT';
